<template>
  <div class="cr-result">
    <div class="cr-container">
      <div class="cr-result__body">
        <div class="cr-result__title cr-result__title--second">
          Войдите или зарегистрируйтесь
        </div>
      </div>
      <div class="cr-result__bottom">
        <router-link class="cr-button cr-button--light" to="/auth/">
                        <span class="cr-button__text">
                            Войти
                        </span>
        </router-link>
        <router-link class="cr-button" to="/registration/">
                        <span class="cr-button__text">
                            Зарегистрироваться
                        </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
